// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1NSyH","title":"ClientReferral_title__3MOhn","itemText":"ClientReferral_itemText__3R6BJ"};